import { Component, ViewContainerRef, ViewChild } from '@angular/core';
import { SiteServices } from '../../services/siteservices';
import { ProviderContext, Providers } from '../../data/Entities';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'settingsapp',
    templateUrl: '/templates/get/Settings/settings',
})
export class SettingsComponent {
    public rows: Array<any> = [];

    public expanded: any = {};

    constructor(public siteServices: SiteServices) {}
}
